
import React,{useState,useEffect,useRef} from "react";
import Main from "../components/template/Main";
import { get,del,put } from "../store/config/register";
import { useHistory ,useParams} from "react-router-dom"; 
import { format,parse } from "date-fns"; 
import { toast } from 'react-toastify';
import {FiUsers, FiFileText} from 'react-icons/fi';
import Compressor from 'compressorjs';
import { toBase64,replaceType } from "../util/Imagem";

const headerProps = {
    icon: "calendar",
    title: "Agenda do dia",
  }

export default function ReservaAgendado(){

    const [maiorHoje,setMaiorHoje]= useState(false);
    const [espaco,setEspaco]=useState({})
    const [agenda,setAgenda]=useState({})
    const [usuario,setUsuario]=useState({})
    const [agendaSelecionada,setAgendaSelecionada]=useState({})
    const [data,setData]=useState(new Date())
        const history =useHistory();
    let hoje =new Date().setHours(0,0,0,0);
    const {id,idAgenda}=useParams();
    const hiddenFileInput = useRef(null);
    
   
    useEffect(()=> {
        buscaEspaco();
        buscaAgenda();
        if(data >= hoje){
            setMaiorHoje(true);
        }
    },[])

    async function buscaAgenda(){
        const agend =await get('/EspacoAgenda/v1/'+ idAgenda);
        if(agend !== undefined){
            VerificaUsuario(agend.login_Id);
            setData(parse(agend.data,"yyyy-MM-dd'T'HH:mm:ss", new Date()));
          setAgenda(agend);
        }
        
      }

      async function VerificaUsuario(login_Id){

        if(login_Id > 0){
          const  result = await  get(`/Login/v1/${login_Id}`);
          setUsuario(result)
       }
       
      }

    async function buscaEspaco() {
        const esp = await get('/Espaco/v1/'+ id);
            if(esp !== undefined){
           setEspaco(esp)
         }
       }

async function removerAgenda() {
  await del('/EspacoAgenda/v1/'+ agenda.id)
  await toast.success('Agendamento cancelado com sucesso!')


}

async function cancelarReserva(item){
  await put(`/EspacoAgenda/v1/Cancelar/${agenda.id}`);
  toast.success('Agendamento cancelado com sucesso!')
  history.push('/ReservaEspaco/'+id)
}


  async function AtualizaAgenda(pagamento, agendaEscolhida) {
            let agend =await get('/EspacoAgenda/v1/'+ agenda.id)
            agend.pagamento =pagamento;
            agend.tipo =agendaEscolhida.tipo;
        
            await put('/EspacoAgenda/v1/'+ agenda.id,agend)
            await toast.success('Pagamento anexado com sucesso');
            window.location.reload();
          }


function convidadoAgenda(){
    history.push('/ReservaEspaco/Convidado/'+ agenda.id)
}

function anexarPagamento() {
    hiddenFileInput.current.click();
}

let type='';
 async function handleFile(e){
    
        if(e.target.files[0]) {
            const image = e.target.files[0];
    
              if(image.type === 'image/jpeg' || image.type === 'image/png' || image.type === 'application/pdf'){
    
                     if(image.type === 'image/jpeg' || image.type === 'image/png'){
                      new Compressor( image, {
                        quality: 0.6, // 0.6 can also be used, but its not recommended to go below.
                        success: async( compressedResult) => {
                          // compressedResult has the compressed file.
                          // Use the compressed file to upload the images to your server.        
                          type = compressedResult.type;
                          let base64 = await toBase64(compressedResult);    
                          let resp =  replaceType(base64);
                          agendaSelecionada.tipo = compressedResult.type;
                         await AtualizaAgenda(resp,agendaSelecionada);
                      },
                      });
                     }else{
                      type =image.type;
                      let base64 = await toBase64(image);  
                      let resp =  replaceType(base64);
                      agendaSelecionada.tipo = image.type;
                     await AtualizaAgenda(resp,agendaSelecionada);
                     }
              
        }
                }else{
                    alert('Envie uma imagem do tipo PNG ou JPEG');
                }
    }

    function renderForm(){
        var cancelamento = hoje + (espaco.desistencia*60*60*1000);
        var horario = format(data,'dd/MM/yyyy');

        horario = parse(horario,'dd/MM/yyyy', new Date()).getTime();

        return(
            <div>
                <div>
                <label>Espaço: <strong>{espaco.nome}</strong></label> 
                <br />   
                <label>{usuario.bloco} - {usuario.unidade} - {usuario.nome}</label> 
                <br />
                 <label>{format(data,'dd/MM/yyyy HH:mm')}</label>
                 <br />
                 <label>Descrição do Evento: {agenda.descricao}</label>
                 <br />
                 <label>Número de convidados: {agenda.numero_Convidado}</label>
                <hr />
                {maiorHoje === true && agenda.unidade_Id === usuario.unidade_Id && (
                     <div className="remover">
                        <button className=" btn btn-danger" onClick={(e) => cancelarReserva()}>Cancelar Reserva</button>
       
                  {espaco.anexo_Pagamento  && (
                    <div>        
                      <button className=" btn btn-success" onClick={(e) => anexarPagamento()} >Anexar Pagamento</button>
                      {agenda.pagamento !== null && (
                                    <FiFileText size={30} color="#000" />
                                 )}       
                    </div>

                  )}

                    
                               
                      <input type="file" accept="image/*" onChange={handleFile} ref={hiddenFileInput}
                        style={{display: 'none'}} // Make the file input element invisible 
                        /><br/>  

                     {espaco.lista_Convidado === true  && (
                            <button  className=" btn btn-light" onClick={ (e) => convidadoAgenda() }>
                            <FiUsers size={23} color="#000" />
                                Convidados
                            </button>
                        )}
                       
                     </div>
                )}
            </div>
            </div>
        );
    }

    return (
        <Main {...headerProps}>
            {renderForm()}
        </Main>
    );
}